module.exports = __webpack_public_path__ + "static/media/faq-illustration-min.126070cb.png";